import * as React from 'react';
import PageMetadata from './components/PageMetadata';
import {Navigate, Route, Routes} from 'react-router-dom';
import AssetReturn from "./components/AssetReturn";
import ClientPortal from "./components/ClientPortal";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import HomePage from "./pages/HomePage";
import BookPage from "./pages/BookPage";
import ClientReservationPage from "./pages/ClientReservationPage";
import OpsLayout from "./pages/ops/OpsLayout";
import OpsInventoryPage from "./pages/ops/OpsInventoryPage";
import OpsReservationsPage from "./pages/ops/OpsReservationsPage";
import OpsReservationNewPage from "./pages/ops/OpsReservationNewPage";
import OpsReservationPage from "./pages/ops/OpsReservationPage";
import OpsCustomersPage from "./pages/ops/OpsCustomersPage";
import StartProjectPage from "./pages/StartProjectPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DataDeletionPage from "./pages/DataDeletionPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import GearPage from "./pages/GearPage";
import ServicePage from "./pages/ServicePage";
import OpsAssetPage from "./pages/ops/OpsAssetPage";
import OpsEngagementsPage from "./pages/ops/OpsEngagementsPage";
import OpsProductsPage from "./pages/ops/OpsProductsPage";
import OpsEngagementNewPage from "./pages/ops/OpsEngagementNewPage";
import ClientEngagementNewPage from "./pages/ClientEngagementNewPage";
import ClientEngagementPage from "./pages/ClientEngagementPage";
import OpsKitPage from "./pages/ops/OpsKitPage";
import OpsKitNewPage from "./pages/ops/OpsKitNewPage";
import OpsTalentPage from "./pages/ops/OpsTalentPage";
import OpsTalentEditPage from "./pages/ops/OpsTalentEditPage";
import OpsDevicesPage from "./pages/ops/OpsDevicesPage";
import OpsOwnersPage from "./pages/ops/OpsOwnersPage";
import TalentFacebookPage from "./pages/TalentFacebookPage";
import {RelayEnvironmentProvider} from "react-relay";
import { relayEnvironment } from './RelayEnvironment';
export const App: React.FC = () => {
    return (
        <RelayEnvironmentProvider environment={relayEnvironment}>
        <PageMetadata/>
        <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/found" element={<AssetReturn/>}/>
            <Route path="/blogs" element={<BlogListPage/>}/>
            <Route path="/blogs/:id" element={<BlogPostPage/>}/>
            <Route path="/book" element={<BookPage/>}/>
            <Route path="/start" element={<StartProjectPage/>}/>
            <Route path="/gear/:tag" element={<GearPage/>}/>
            <Route path="/services/:slug" element={<ServicePage/>}/>
            <Route path="/contact" element={<StartProjectPage/>}/>
            <Route path="/privacy" element={<PrivacyPolicyPage/>}/>
            <Route path="/data-deletion" element={<DataDeletionPage/>}/>
            <Route path="/terms" element={<TermsOfServicePage/>}/>
            <Route path="/client" element={<ClientPortal/>}/>
            <Route path="/client/reservations/:id" element={<ClientReservationPage/>}/>
            <Route path="/client/engagements/new" element={<ClientEngagementNewPage/>}/>
            <Route path="/client/engagements/:id" element={<ClientEngagementPage/>}/>
            <Route path="/talent/connect/:token" element={<TalentFacebookPage/>}/>
            <Route path="/talent/facebook" element={<TalentFacebookPage/>}/>
            <Route path="/ops" element={<OpsLayout/>}>
                <Route index element={<Navigate to="/ops/reservations" replace/>}/>
                <Route path="reservations" element={<OpsReservationsPage/>}/>
                <Route path="reservations/new" element={<OpsReservationNewPage/>}/>
                <Route path="reservations/:id" element={<OpsReservationPage/>}/>
                <Route path="customers" element={<OpsCustomersPage/>}/>
                <Route path="products" element={<OpsProductsPage/>}/>
                <Route path="engagements" element={<OpsEngagementsPage/>}/>
                <Route path="engagements/new" element={<OpsEngagementNewPage/>}/>
                <Route path="inquiries" element={<Navigate to="/ops/engagements" replace/>}/>
                <Route path="inventory" element={<OpsInventoryPage/>}/>
                <Route path="inventory/new" element={<OpsAssetPage/>}/>
                <Route path="inventory/:id" element={<OpsAssetPage/>}/>
                <Route path="owners" element={<OpsOwnersPage/>}/>
                <Route path="kits/new" element={<OpsKitNewPage/>}/>
                <Route path="kits/:id" element={<OpsKitPage/>}/>
                <Route path="talent" element={<OpsTalentPage/>}/>
                <Route path="talent/new" element={<OpsTalentEditPage/>}/>
                <Route path="talent/:id" element={<OpsTalentEditPage/>}/>
                <Route path="devices" element={<OpsDevicesPage/>}/>
            </Route>
            <Route path="*" element={<main className="p-12 text-white"><h1>Page not found</h1><a href="/">Return home</a></main>}/>
        </Routes>
            </RelayEnvironmentProvider>
    );
};

export default App;